import { PORTAL_USER_TYPE } from "@/app/models";
import type { PortalUser } from "@/app/models";
import { usePortalUserStore } from "@/app/stores";
import { isInactiveSubscription } from "@/features/consultations/utils";
import {
  AMAZON_BUTTON_ID,
  connectAmazonChat,
  useAmazonChat,
} from "@/shared/lib/amazon-connect";

export const useMessenger = () => {
  const portalUser = usePortalUserStore((state) => state.portalUser);

  const {
    actions: {
      toggleChatVisibility: toggleAmazonChat,
      showChat: showAmazonChat,
      hideChat: hideAmazonChat,
    },
  } = useAmazonChat();

  const canOpenMessenger =
    (portalUser?.type === PORTAL_USER_TYPE.PATIENT ||
      portalUser?.type === PORTAL_USER_TYPE.COACHING) &&
    !portalUser?.subscriptions.every((subscription) =>
      isInactiveSubscription(subscription.status),
    );

  const initializeMessenger = (portalUser: PortalUser) => {
    if (
      portalUser.subscriptions.some(
        (subscription) => !isInactiveSubscription(subscription.status),
      )
    ) {
      connectAmazonChat({
        name: portalUser.name,
        phoneNumber: portalUser.phoneNumber,
        email: portalUser.email,
      });
    }
  };

  const showMessenger = () => {
    document.getElementById(AMAZON_BUTTON_ID)?.click();
    showAmazonChat();
  };

  const hideMessenger = () => {
    hideAmazonChat();
  };

  const toggleMessengerVisibility = () => {
    document.getElementById(AMAZON_BUTTON_ID)?.click();
    toggleAmazonChat();
  };

  return {
    canOpenMessenger,

    actions: {
      initializeMessenger,
      toggleMessengerVisibility,
      showMessenger,
      hideMessenger,
    },
  };
};
